var badge = '_1am71xq4';
var badgeText = '_1am71xq5';
var hasIconPrefix = '_1am71xq6';
var icon = '_1am71xqb';
var size = {md:'_1am71xq7 _14wijgr9',lg:'_1am71xq8 _14wijgr7'};
var variant = {defaultFilled:'_1am71xqc _1am71xq9',defaultOutline:'_1am71xqd _1am71xqa',inverseFilled:'_1am71xqe _1am71xq9',brandFilled:'_1am71xqf _1am71xq9',brandOutline:'_1am71xqg _1am71xqa',componentFilled:'_1am71xqh _1am71xq9',componentOutline:'_1am71xqi _1am71xqa',successFilled:'_1am71xqj _1am71xq9',successOutline:'_1am71xqk _1am71xqa',warningFilled:'_1am71xql _1am71xq9',warningOutline:'_1am71xqm _1am71xqa',dangerFilled:'_1am71xqn _1am71xq9',dangerOutline:'_1am71xqo _1am71xqa',inactiveFilled:'_1am71xqp _1am71xq9',inactiveOutline:'_1am71xqq _1am71xqa',onFill:'_1am71xqr _1am71xq9'};

export { badge, badgeText, hasIconPrefix, icon, size, variant };
//# sourceMappingURL=badge.css.js.map
